import dayjs from "dayjs";

import { DataTableStatic } from "@/components/datatable/data-table-static";

import { Job } from "@/hooks/services/pps/types/job-orders.type";

import { BadgeStatus, TechnicianAvatars } from "@/lib/utils";

function AiListContent({
  data,
  isLoading,
  onSelectedDatasChange,
}: {
  data: any;
  isLoading: boolean;
  onSelectedDatasChange?: (selectedDatas: any[]) => void;
}) {
  return (
    <DataTableStatic<Job>
      data={data || []}
      isLoading={isLoading}
      onSelectionChange={onSelectedDatasChange}
      features={{ enablePagination: false }}
      columns={[
        {
          accessorKey: "jobOrderNo",
          header: "Job Order No",
          cell: ({ row }) => row.original.jobOrderNo || "-",
        },
        {
          header: "Part Number",
          cell: ({ row }) => row.original?.part?.partNumber || "-",
        },
        {
          header: "Part Description",
          cell: ({ row }) => row.original?.part?.partDescription || "-",
        },
        {
          accessorKey: "status",
          header: "Status",
          cell: ({ row }) => (
            <BadgeStatus status={row.original.status.statusName} />
          ),
        },
        {
          accessorKey: "ppsTechnicians",
          header: "Technicians",
          cell: ({ row }) => (
            <TechnicianAvatars technicians={row.original.ppsTechnicians} />
          ),
        },
        {
          accessorKey: "dueDate",
          header: "Shop Edd1",
          cell: ({ row }) =>
            row.original.dueDate
              ? dayjs(row.original.dueDate).format("YYYY-MM-DD")
              : "-",
        },
        {
          accessorKey: "costCentre",
          header: "Cost Centre",
          cell: ({ row }) => row?.original?.costCentre || "-",
        },
        {
          accessorKey: "customer",
          header: "Customer",
          cell: ({ row }) => row?.original?.customer?.customerName || "-",
        },
        {
          accessorKey: "startDate",
          header: "Strtmlfn",
          cell: ({ row }) =>
            row.original.startDate
              ? dayjs(row.original.startDate).format("YYYY-MM-DD")
              : "-",
        },

        {
          accessorKey: "standardHours",
          header: "QuotedFFP Lab HR",
          cell: ({ row }) => (
            <span>
              {row.original?.standardHours
                ? dayjs(
                    dayjs(row.original?.standardHours, "HH:mm:ss").toDate(),
                  ).format("HH:mm")
                : "-"}
            </span>
          ),
        },
        {
          accessorKey: "totalCost",
          header: "Act total cost",
          cell: ({ row }) => row?.original?.totalCost || "-",
        },
        {
          accessorKey: "totalSales",
          header: "SOSales",
          cell: ({ row }) => row?.original?.totalSales || "-",
        },
        {
          accessorKey: "materialStatus",
          header: "Mat Status",
          cell: ({ row }) => row?.original?.materialStatus || "-",
        },
        {
          accessorKey: "materialEdd",
          header: "Mat EDD",
          cell: ({ row }) =>
            row?.original?.materialEdd
              ? dayjs(row.original.materialEdd).format("YYYY-MM-DD")
              : "-",
        },
        {
          accessorKey: "pbsubcontStatus",
          header: "PSubcont Status",
          cell: ({ row }) => row?.original?.pbsubcontStatus || "-",
        },
        {
          accessorKey: "pbsubcontEdd",
          header: "PSubCont Edd",
          cell: ({ row }) =>
            row?.original?.pbsubcontEdd
              ? dayjs(row.original.pbsubcontEdd).format("YYYY-MM-DD")
              : "-",
        },
        {
          accessorKey: "prodRemarks",
          header: "Prod Remarks",
          cell: ({ row }) => row?.original?.prodRemarks || "-",
        },
      ]}
    />
  );
}

export default AiListContent;
